// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"17c77e6ccf23a913","src_app_features_home_home_module_ts":"695d88c2e0a71f25","src_app_features_booking_booking_module_ts":"6b6ea1433084635f"}[chunkId] + ".js";
};